import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './PublicNav.css';

const PublicNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="public-nav">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          {/* <span className="logo-icon"></span>
          <span className="logo-text">ProjectPro</span> */}
          <img src='/logo_ppm_dark.svg' style={{width:'7rem'}}/>
        </Link>

        <div className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <Link 
            to="https://yesppm.com/" 
            className={`nav-link ${isActive('/')}`}
            onClick={() => setIsOpen(false)}
          >
            Home 
          </Link>
          <Link 
            to="/about" 
            className={`nav-link ${isActive('/about')}`}
            onClick={() => setIsOpen(false)}
          >
            About
          </Link>
          <Link 
            to="/services" 
            className={`nav-link ${isActive('/services')}`}
            onClick={() => setIsOpen(false)}
          >
            Services
          </Link>
          <Link 
            to="/pricing" 
            className={`nav-link ${isActive('/pricing')}`}
            onClick={() => setIsOpen(false)}
          >
            Pricing
          </Link>
          <Link
            to="/contact"
            className={`nav-link ${isActive('/contact')}`}
            onClick={() => setIsOpen(false)}
          >
            Contact
          </Link>
          <Link
            to="/schedule-demo"
            className={`nav-link ${isActive('/schedule-demo')}`}
            onClick={() => setIsOpen(false)}
          >
            Schedule Demo
          </Link>
          
          <div className="nav-auth">
            <Link 
              to="/login" 
              className="nav-link-btn login-btn"
              onClick={() => setIsOpen(false)}
            >
              Login
            </Link>
            <Link 
              to="/register" 
              // className="nav-link-btn signup-btn"
              // onClick={() => setIsOpen(false)}
            >
              {/* Sign Up */}
            </Link>
          </div>
        </div>

        <button className="nav-toggle" onClick={toggleMenu}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
    </nav>
  );
};

export default PublicNav;


